<ul>
    <slot></slot>
</ul>

<style>
    ul {
        list-style: none;
        margin: 0 0 0.5rem;
        padding: 0;
    }
</style>